/**
 * Loading Overlay
 * Shows a loading spinner over content
 */

import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';
import { colorPalette } from '../../theme';

const LoadingOverlay = ({ loading, message = 'Loading...' }) => {
  if (!loading) return null;

  return (
    <Fade in={loading}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
          backdropFilter: 'blur(2px)',
        }}
      >
        <CircularProgress
          size={48}
          sx={{ color: colorPalette.asseTracOrange }}
        />
        {message && (
          <Typography
            variant="body2"
            sx={{ mt: 2, color: 'white' }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Fade>
  );
};

export default LoadingOverlay;
